__turbopack_context__.v({
  "btn": "styles-module-scss-module__vY4AfG__btn",
  "classNameRoot": "styles-module-scss-module__vY4AfG__classNameRoot",
  "content": "styles-module-scss-module__vY4AfG__content",
  "description": "styles-module-scss-module__vY4AfG__description",
  "gamePreview": "styles-module-scss-module__vY4AfG__gamePreview",
  "games": "styles-module-scss-module__vY4AfG__games",
  "locationImage": "styles-module-scss-module__vY4AfG__locationImage",
  "root": "styles-module-scss-module__vY4AfG__root",
  "shimmer": "styles-module-scss-module__vY4AfG__shimmer",
  "skeletonBox": "styles-module-scss-module__vY4AfG__skeletonBox",
  "title": "styles-module-scss-module__vY4AfG__title",
});
